class TabItems extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[data-tab]');
    this.tabSwitchers = this.querySelectorAll('[data-tab-switcher]');

    this.tabSwitchers.forEach((tabSwitcher) => {
      tabSwitcher.addEventListener('click', this.switchTab.bind(this));
    })
  }

  switchTab(event) {
    const tabSwitcher = event.target;
    if (tabSwitcher.getAttribute('aria-active') == 'true') {
      return;
    }
    this.tabSwitchers.forEach((tabSwitcher) => {
      tabSwitcher.setAttribute('aria-active', false);
    })

    tabSwitcher.setAttribute('aria-active', true);
    const tabIndex = tabSwitcher.dataset.switchTo;

    console.log(tabIndex);
    this.tabs.forEach((tab) => {
      tab.setAttribute('aria-hidden', tab.dataset.tabIndex != tabIndex);
    });
  }
}

customElements.define('tab-items', TabItems);